var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fullUrl)?_c('img',{style:(_vm.style),attrs:{"src":_vm.fullUrl,"width":_vm.width}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }